import { Component, ElementRef, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';
import { BrdsqlService } from '../../services/brdsql.service';

@Component({
  selector: 'app-print-report-cut-f',
  templateUrl: './print-report-cut-f.component.html',
  styleUrls: ['./print-report-cut-f.component.css']
})
export class PrintReportCutFComponent {
  userdata: any;
  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService, private brdsql: BrdsqlService) {
    this.userdata = this.auth.Authention();
    this.supzone = brdsql.sumZonne;
  }
  supzone: any[] = []

  ngOnInit(): void {
    //this.Loaddata1()
  }
  compNums(a: number, b: number) { return a - b; }
  loading: boolean[] = [false, false, false, false, false, false];

  yearN = { "yearTh": "6869", "yearlf": "68", "yearCr": "2526", "yearDesc": "ปี 2568/2569", "yearTh_n": "6970", "yearDesc_n": "ปี 2569/2570", "state": 1 };
  isChecked: boolean = false;
  edit_st = 0;
  selectS: any[] = [];
  todaydate = '';
  dataApi0: any[] = [];
  dataApi1: any[] = [];

  sum_Group: any[] = []; list_data_s: any[] = [];

  h_url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/'

  params_like1 = {
    search: '', pageSize: 15, col_like_n: []
  };
  data_list: any[] = [];
  LoadDataLike1() {
    this.todaydate = new Date().toLocaleString('th-TH', { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
    let search = this.params_like1.search.trim();
    let url = `${this.h_url}function-3/datatable_w`; // เปลี่ยนเป็น URL ของ Cloud Function
    const params = {
      table: `dbo.v_cutF_${this.yearN.yearTh}`,
      column: '*',
      col_like: 'fmcode,fmname',
      length: 15,
      search: search,
      orderColumn: 1,
    };
    if (search.length > 0) {
      this.loading[0] = true;
      axios.get(url, { params }).then(res => {
        const data = res.data;
        this.loading[0] = false;
        this.data_list = data.data;
        this.isChecked = false;
        //console.log('farmer_list:', data);
      }).catch(err => { throw err })
    }
    else {
      this.data_list = [];
    }
  }

  push_dataone(data: any, state: number) {
    //console.log('push_dataone:', data, state);
    let data_n = this.selectS.filter(el => el.farmer_id != data.farmer_id);
    this.selectS = data_n;
    if (state == 1) this.selectS.push(data);
    this.filter_data2()
  }

  async selectOption(list: any, num: number) {
    /*
    this.fm_data = list;
    const date = new Date();
    this.params_like1.search = `[${list.fmcode_b1}] ชื่อ:${list.fmname}, โซน:${list.SUPZONE}`;
    this.data_list = [];
    console.log('Select option:list', list);
    this.farmer_id = list.farmer_id;
    this.fmcode = list.fmcode_b1;
    this.fmname = list.fmname;
    this.Finddata()
    */
    /*await this.Loadfarmerplant();
    await this.LoadDataPlantbyfamer()
    */
  }

  groupCode = '';
  Loaddata2() {
    this.todaydate = new Date().toLocaleString('th-TH', { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
    this.loading[0] = true;
    //let url = this.h_url + `function-2/select_sfw?s=*&f=[dbo].[fnc_cutF${this.yearN.yearTh}]('${this.groupCode}')&w=1=1`;    
    let url = this.h_url + `function-2/select_sfw?s=*&f=[dbo].[v_cutF_${this.yearN.yearTh}]&w=1=1 order by[SUPZONE]`;
    axios.get(url).then(res => {
      this.loading[0] = false;
      let data = res.data;
      if (data.length > 0) {
        //data = data.map(item => { return { ...item, select: false }; });
        this.dataApi0 = data;
        //console.log('Loaddata2:', data);
      }
      else { this.dataApi0 = []; }
    }).catch(err => { throw (err) })
  }


  farmer_group: any[] = [];
  g_farmer: any[] = [];
  filter_data2() {
    let data = this.selectS;
    if (data.length == 0) return;
    this.loading[2] = true;
    data.forEach(async (item: any) => {
      if (item.farmer_id) {
        if (!this.farmer_group.includes(item.farmer_id)) {
          this.farmer_group.push(item.farmer_id);
          await this.Load_plant_fm0(item.farmer_id)
        }
      }
    });
    this.loading[2] = false;

    /*this.g_farmer = [];
    this.g_farmer = [...new Set(data.map(function (elem) { return (elem.fmname) }))].sort(this.compNums);
    */
    /*
     console.log('selectS:', data);
     console.log('farmer_group:', this.farmer_group);
     console.log('plant_fm:', this.data_plant_fm);
    */
  }

  scrollTo(element: any): void {
    (document.getElementById(element) as HTMLElement).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  async printPage() {
    window.print();
  }

  calPercent(total: number, part: number): number {
    if (total == 0 || part == 0) return 0;
    let num: number = parseFloat(((part / total) * 100).toFixed(2));
    return num;
  }

  data_plant_fm: any[] = [];
  async Load_plant_fm(farmer_id: number) {
    let url = this.h_url +
      `function-2/select_sfw?s=[areasID],[intlandno],[farmer_id],[supzone],[supname],[landvalue_left],[canetype],[CaneTypeName],[target_yield],[target_cane]&f=[dbo].[v_cp${this.yearN.yearTh_n}_basic]&w=farmer_id=${farmer_id} order by [intlandno]asc`;
    axios.get(url).then(res => {
      let data = res.data;
      if (data.length > 0) {
        this.data_plant_fm.push(...data);
        //console.log('Loaddata2:', data);
      }
    }).catch(err => { throw (err) })
  }

  getPlantDataByFarmerId(farmer_id: number): any[] {
    return this.data_plant_fm.filter(item => item.farmer_id == farmer_id);
  }

  data_plant_fm0: any[] = [];
  async Load_plant_fm0(farmer_id: number) {
    let url = this.h_url + `function-2/select_sfw?s=*&f=[dbReport].[dbo].[v_cp_data]&w=farmer_id=${farmer_id}and year_id=9 order by [intlandno]asc`;
    axios.get(url).then(res => {
      let data = res.data;
      if (data.length > 0) {
        this.data_plant_fm0.push(...data);
        //console.log('Loaddata2:', data);
      }
    }).catch(err => { throw (err) })
  }

  getPlantDataByFarmerId0(farmer_id: number): any[] {
    return this.data_plant_fm0.filter(item => item.farmer_id == farmer_id);
  }

}
